import { Routes } from '@angular/router';

import AppShellComponent from './app-shell.component';

// Страницы, которые все три сайта собирают заранее. Список один: серверные маршруты каждого
// приложения строят по нему пререндер, а неизвестный адрес отдают серверу с кодом 404.
export const PRERENDERED_PATHS: readonly string[] = [
    'calc',
    'calc/straight',
    'calc/l',
    'calc/u',
    'calc/spiral',
    'catalog',
    'order',
    'about',
    'contacts',
    'privacy',
    'terms',
    'cookies',
];

const appRoutes: Routes = [
    {
        path: '',
        component: AppShellComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadComponent: () => import('@stair-craft/home/home'),
                data: {
                    seoTitle: $localize`:@@seoHomeTitle:GoldenCalc — конструктор деревянных лестниц`,
                    seoDescription: $localize`:@@seoHomeDesc:Онлайн-конструктор деревянных лестниц для мастерских и застройщиков: геометрия по СНиП и ГОСТ, проверка норм, объём древесины, экспорт в JSON, PNG и DXF.`,
                },
            },
            {
                path: 'calc',
                loadChildren: () => import('@stair-craft/calc/shell'),
            },
            {
                path: 'projects',
                loadChildren: () => import('@stair-craft/projects/shell'),
                data: {
                    breadcrumb: $localize`:@@projectsListTitle:Мои проекты`,
                },
            },
            {
                path: 'catalog',
                loadChildren: () => import('@stair-craft/catalog/shell'),
                data: {
                    breadcrumb: $localize`:@@breadcrumbCatalog:Каталог`,
                },
            },
            {
                path: 'order',
                loadChildren: () => import('@stair-craft/order/shell'),
            },
            {
                path: 'blog',
                loadChildren: () => import('@stair-craft/blog/shell'),
                data: {
                    breadcrumb: $localize`:@@navBlog:Блог`,
                },
            },
            {
                path: '',
                loadChildren: () => import('@stair-craft/legal/shell'),
            },
            {
                path: 'about',
                loadComponent: () => import('@stair-craft/about/about'),
                data: {
                    breadcrumb: $localize`:@@navAboutProject:О проекте`,
                    seoTitle: $localize`:@@seoAboutTitle:О проекте — GoldenCalc`,
                    seoDescription: $localize`:@@seoAboutDesc:GoldenCalc — параметрический конструктор деревянных лестниц. Возможности, принципы работы и контакты команды.`,
                },
            },
            {
                path: 'contacts',
                loadComponent: () => import('@stair-craft/contacts/contacts'),
                data: {
                    breadcrumb: $localize`:@@navContacts:Контакты`,
                    seoTitle: $localize`:@@seoContactsTitle:Контакты — GoldenCalc`,
                    seoDescription: $localize`:@@seoContactsDesc:Связаться со студией GoldenCalc: форма обратной связи для вопросов о конструкторе лестниц, расчётах и заказе изготовления.`,
                },
            },
            {
                path: '**',
                loadComponent: () => import('@stair-craft/not-found/not-found'),
                data: {
                    seoTitle: $localize`:@@seoNotFoundTitle:Страница не найдена — GoldenCalc`,
                    seoDescription: $localize`:@@seoNotFoundDesc:Страница не найдена. Вернитесь на главную или откройте конструктор.`,
                },
            },
        ],
    },
];

export default appRoutes;
